import React from 'react';

import * as Styled from './Image.styled';

const Image = ({ img, alt, ...rest }) => (
	<Styled.Img src={img} alt={alt} {...rest} />
);

export default Image;
